import { render, staticRenderFns } from "./appSetDialog2.vue?vue&type=template&id=51c22312&scoped=true"
import script from "./appSetDialog2.vue?vue&type=script&lang=js"
export * from "./appSetDialog2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c22312",
  null
  
)

export default component.exports